import React, { useState, useEffect } from 'react';
import { Empty, message, Popconfirm, Spin, Table, TableProps, } from 'components/shared/AntComponent';
import { Input, Button, Radio } from 'components/shared/FormComponent';
import { DeleteFilled, SearchOutlined } from 'components/shared/AntIcons';
import { useDispatch } from 'react-redux';
import { getDegreeList } from 'services/store/actions/candidateAction';
import { useSelector } from 'react-redux';
import { EditIcon, EyeIcon } from 'assets/icons/CustomIcons';
import AddDegreeSpecialisationModal from './modal/AddDegreeSpecialisationModal';
import { deleteDegree, deleteSpecialization, getAllSpecialisation } from 'services/store/actions/masterDataAction';

interface DataType {
    key: number;
    sno: number;
    account_name: string;
    account_number: string;
    city: string;
    created_on: string;
}

const SpecialisationMaster: React.FC = () => {
    const dispatch = useDispatch();
    const { loading23, success23, error23, loading11, specmasInfo } = useSelector((state: any) => state.master);
    const data: any = !loading11 && specmasInfo && specmasInfo?.data ? specmasInfo?.data?.data : [];
    const [searchValue, setSearchValue] = useState('');
    const [accStatus, setAccStatus] = useState("Active");
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [openModal, setOpenModal] = useState(false);
    const [rowData, setRowData]: any = useState(null);
    const [degreeID, setDegreeID] = useState(0);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success23 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error23 : false;
    const totalRecords = !loading11 && specmasInfo && specmasInfo?.data ? specmasInfo?.data?.totalRecords : 0;
    const [modalTitle, setModalTitle] = useState('');

    const customLocale = {
        emptyText: <Empty className="p-2" description={accStatus === 'Active' ?"No Specialization available":"No Inactive specialization available"} />,
    };

    const columns: TableProps<DataType>['columns'] = [
        {
            title: 'S.No',
            dataIndex: 'sno',
            key: 'sno',
            render: (id, record, index) => {
                if (pageIndex === 1) {
                    return index + 1;
                } else {
                    return (pageIndex - 1) * pageSize + (index + 1);
                }
            },
        },
        {
            title: 'Specialisation Name',
            dataIndex: 'specializationName',
            key: 'specializationName',
            filteredValue: [searchValue],
            onFilter: (value: any, record: any) => record?.specializationName.toLowerCase()?.includes(value?.toLowerCase()),
            sorter: (a: any, b: any) =>
                (a?.specializationName || '').toLowerCase().localeCompare((b?.specializationName || '').toLowerCase()),
            // width: '55%',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Submitted Date',
            dataIndex: 'createdOn',
            key: 'createdOn',
            render: (createdOn) => {
                const originalDate = new Date(createdOn) || null;
                return data ? originalDate?.toLocaleString() : null;
            },
        },
        {
            title: 'Status',
            dataIndex: 'isActive',
            key: 'isActive',
            render: (_: any, record: any) => {
                return (
                    <div>{record?.isActive ? <div className="bg-success px-2 py-1 text-white rounded text-center d-inline-block">Active</div> :
                        <div className="bg-danger px-2 py-1 text-white rounded d-inline-block text-center">Inactive</div>}</div>
                )
            }
        },
        {
            title: 'Action',
            dataIndex: 'actions',
            key: 'actions',
            render: (_: any, record: any) => {
                return (
                    <div className="d-flex w-100">
                        <div className="pointer my-auto pb-3" onClick={() => editQuestion(record)}>
                            <EditIcon size={34} />
                        </div>
                        {/* <div className="text-warning pointer eye-icon me-2 my-auto" onClick={() => viewDetails(record)}>
                            <EyeIcon size={20} />
                        </div> */}
                        <div className="my-auto delete-icon">
                            <Popconfirm title="Delete Specialization" description="Are you sure to delete this specialization?" onConfirm={() => { deleteQuestion(record); setDegreeID(record?.id) }} okText="Yes" cancelText="No">
                                <DeleteFilled className="text-danger pointer del-icon" />
                            </Popconfirm>
                        </div>
                    </div>
                );
            },
        },
    ];

    const editQuestion = (val: any) => {
        setOpenModal(true);
        setRowData(val);
        setModalTitle("Update Specialization");
    }

    const deleteQuestion = (val: any) => {
        const id =  Number(localStorage.getItem('tenantID')) + '/' + val?.specializationId;
        dispatch(deleteSpecialization(id) as any);
        setShowErrormsg(true);
        setShowSuccessmsg(true);
    }

    const handleCancel = () => {
        setOpenModal(false);
    }

    const handleOpenModal = () => {
        setOpenModal(true);
        setRowData(null);
        setModalTitle("Add Specialization");
    }

    // Pagination configuration
    const paginationConfig: TableProps<DataType>['pagination'] = {
        position: ['bottomRight'],
        current: pageIndex,
        pageSize: pageSize,
        total: totalRecords,
        onChange: (page: number, pageSize: number) => {
            setPageIndex(page);
            setPageSize(pageSize);
            getMasSepcialisation(page, pageSize, searchValue, accStatus);
        },
        itemRender: (current: any, type: string, originalElement: any) => {
            if (type === 'prev') {
                return <Button className="prev-btn">Previous</Button>;
            }
            if (type === 'next') {
                return <Button className="next-btn">Next</Button>;
            }
            return originalElement;
        },
    };
    const handleSearch = (e: any) => {
        if (e.key === 'Enter') {
            setSearchValue(e.target.value);
            setPageIndex(1);
            getMasSepcialisation(1, pageSize, e.target.value, accStatus);
        }
    };
    const resetSearch = (e: any) => {
        if (e.key === 'Backspace' && !e.target.value) {
            setSearchValue(e.target.value);
            setPageIndex(1);
            getMasSepcialisation(1, pageSize, e.target.value, accStatus);
        }
    };

    const getMasSepcialisation = (page: number, size: number, search: string, accStatus: string) => {
        const inputJson = {
            "InputData": {
                "IsActive": accStatus?.toLowerCase() === 'active' ? true : false,
                "TenantId":  Number(localStorage.getItem('tenantID'))
            },
            "DataFinder": {
                "PageSize": size,
                "CurrentPage": page,
                "SortByColumn": "",
                "SortBy": "asc",
                "SearchData": search || ""
            }
        }
        dispatch(getAllSpecialisation(inputJson) as any);
    }

    useEffect(() => {
        getMasSepcialisation(pageIndex, pageSize, searchValue, accStatus);
    }, []);

    useEffect(() => {
        if (successmsg) {
            message.success("Specialization deleted successfully");
            setPageIndex(1);
            setSearchValue('');
            getMasSepcialisation(1, pageSize, "", accStatus);
            setShowSuccessmsg(false);
        }
        if (errormsg) {
            if (error23?.message) {
                message.error(error23?.message);
            } else {
                message.error("Specialization couldn't be deleted");
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    const callbackFunc = () => {
        setPageIndex(1);
        setSearchValue('');
        getMasSepcialisation(1, pageSize, "", accStatus);
    }

    const handleStatusChange = (e: any) => {
        setPageIndex(1);
        setSearchValue('');
        setAccStatus(e.target.value);
        getMasSepcialisation(1, pageSize, '', e?.target?.value);
    }

    return (
        <div className="my-3 children-container">
            <div className="row mx-0 mb-2 page-header">
                <h6 className="col-md-3 text-start text-secondary my-auto fw-bold">Specialization</h6>
                <div className="col-md-8 pe-1 d-flex ms-auto">
                    <div className="col-md-5 text-start pe-2 ms-auto d-flex">
                        <div className="d-flex me-2">
                            <Radio.Group defaultValue={accStatus} buttonStyle="solid" size="small" className="col pe-0 d-flex" onChange={handleStatusChange}>
                                <Radio.Button className="active" value="Active">
                                    Active
                                </Radio.Button>
                                <Radio.Button className="inactive px-2" value="Inactive">
                                    Inactive
                                </Radio.Button>
                            </Radio.Group>
                        </div>
                        <Input
                            prefix={<SearchOutlined />}
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                            onKeyDown={(e) => handleSearch(e)}
                            onKeyUp={(e) => resetSearch(e)}
                            placeholder="Search"
                        />

                        <Button type="primary" onClick={handleOpenModal} className="bg-primary ms-2">
                            Add
                        </Button>
                    </div>
                </div>
            </div>
            <div className="row m-0 custom-table px-0">
                <Spin spinning={loading23} className="text-danger" tip="Deleting...">
                    <Table columns={columns} scroll={{ x: 'calc(230px + 50%)' }}
                        className="shadow-sm border" dataSource={data} rowKey="specializationId" loading={loading11} pagination={paginationConfig} locale={customLocale} />
                </Spin>
            </div>
            <AddDegreeSpecialisationModal openModal={openModal} closeModal={handleCancel} rowData={rowData} callbackFunc={callbackFunc} modalTitle={modalTitle} requestFrom={1} />
        </div>
    )
}

export default SpecialisationMaster;